const getters = {
  userName: (state: any): string => state.user.userName,
};

export default getters;
